var _path, _path2, _path3, _path4, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrainAndTrack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1992 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M836.152 49.252C1007.11 106.075 1052.89 175.452 1048.97 203.279C1039.56 226.794 978.421 236.201 949.026 236.201H678.597H665.189H538.205H524.57H56.6108C43.6389 236.075 42.8934 236.467 37.7983 236.075H-78.6035C-102.119 236.075 -99.1156 236.075 -107.998 236.201H-157.381H-195.006C-210.997 229.616 -215.778 213.861 -216.17 206.806V53.9551C-216.17 25.7364 -214.994 23.3848 -206.764 11.6271C-200.179 2.22084 -171.098 0.653186 -157.381 1.04514C17.0264 -1.30642 456.375 1.04514 456.375 1.04514C456.375 1.04514 665.189 -7.57111 836.152 49.252Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M766.78 163.127H1032.84C1052.34 189.429 1050.3 198.793 1048.34 203.104H677.421H-216.169V188.994C46.4211 189.778 576.305 190.876 595.117 188.994C613.929 187.113 602.955 167.83 595.117 158.424C573.953 131.381 529.273 74.4738 519.867 63.1863C510.461 51.8989 496.352 49.8608 490.473 50.2528H196.529H-216.169V39.6708H196.529H515.164C553.965 39.6708 573.953 42.0223 611.578 72.5925C684.946 145.02 745.616 163.127 766.78 163.127Z",
    fill: "#FF5E55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M709.167 88.0525H932.565C893.059 64.5369 818.431 41.9241 783.941 33.3017C740.046 32.9098 642.383 31.8504 619.808 32.791C591.589 33.9668 602.171 41.0215 624.511 53.955C657.433 81.233 694.666 88.0525 709.167 88.0525Z",
    fill: "#387999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M488.392 70.8274L488.392 70.8274H-215.899V110.432C28.6809 110.713 518.739 111.478 527.192 110.804C535.645 110.13 533.066 104.435 529.544 100.222C526.022 96.0086 520.192 89.7175 511.971 80.9391C502.501 70.8274 495.435 70.8274 488.392 70.8274Z",
    fill: "#204B61"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.34082,
    y: 239.929,
    width: 1992,
    height: 55,
    fill: "#16387F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainAndTrack);
export default __webpack_public_path__ + "static/media/TrainAndTrack.ce14bb12.svg";
export { ForwardRef as ReactComponent };